import { AbstractControl, ValidatorFn } from '@angular/forms';

export const checkedValidator = (): ValidatorFn => {
  return (control: AbstractControl) => {
    const value = control.value;

    return (value !== true)
      ? { notChecked: true }
      : null;
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/validators/checked.validator.ts